import React from "react"
import PropTypes from "prop-types"
import ConnectSectionHeader from './ConnectSectionHeader'
import ConnectMemberCard from './ConnectMemberCard'

class MissedConnects extends React.Component {
  render() {
    return(
      <section className="connectsSection connectsSection--missed">
        <ConnectSectionHeader
          icon="hourglass"
          title="Missed Connections"
          subtitle="You have 7 days to accept a Connect Request. These people want to connect, but the request expired. Want to try again? Try sending them a request!"
        />
        <div className="connectsHorizontalRow connectsHorizontalRow--missed">
          {this.props.missedConnects.map((connect, i) => (
            <ConnectMemberCard
              key={connect.id || i}
              user={connect.requestor}
              connectMessage={connect.msg}
              missingImg={this.props.missingImg}
              variant="missed"
            />
          ))}
        </div>
      </section>
    )
  }
}

MissedConnects.propTypes = {
  missingImg: PropTypes.string.isRequired,
  missedConnects: PropTypes.array.isRequired,
}

export default MissedConnects
